module.exports = __webpack_public_path__ + "m4a/win.m4a?eb96e0478f63c997f31c5256e25cb416";